export const radii = [0, 0.3, 0.5, 0.75, 1]

export const themes = {
  "light-bilkent": {
    label: "Bilkent",
    activeColor: {
      light: "210 100% 31%",
      dark: "210 100% 31%",
      foreground: "0 0% 100%",
    },
  },
}
